import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFacebook, FiInstagram, FiYoutube, FiMail, FiPhone, FiMapPin, FiHeart, FiTwitter, FiCrosshair } = FiIcons;

const Footer = () => {
  const quickLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Weekly Services', href: '/services' },
    { name: 'Church Ministries', href: '/ministries' },
    { name: 'Upcoming Events', href: '/events' },
    { name: 'Contact Us', href: '/contact' }
  ];

  const socialLinks = [
    { icon: FiFacebook, label: 'Facebook', href: 'https://www.facebook.com/share/p/16ibmMBrhk/' },
    { icon: FiTwitter, label: 'Twitter', href: 'https://x.com/SSC_Bota?t=b_o5neHT08oi7MZZ6qDVeg&s=08' },
    { icon: FiYoutube, label: 'YouTube', href: 'https://www.youtube.com/@SSC_Bota/' },
    { icon: FiInstagram, label: 'TikTok', href: 'https://www.tiktok.com/@southernsaviours?_t=ZS-8zPWWshED1U&_r=1' }
  ];

  return (
    <footer className="bg-gray-950 text-white pt-20 pb-10 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="col-span-1 lg:col-span-1">
            <Link to="/" className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiCrosshair} className="text-white text-xl" />
              </div>
              <span className="text-2xl font-black tracking-tighter">SSC BOTA</span>
            </Link>
            <p className="text-gray-400 leading-relaxed mb-8">
              Empowering lives through the Word of God since 2009. A beacon of light and hope in the heart of Port Harcourt.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, idx) => (
                <a 
                  key={idx} href={social.href} target="_blank" rel="noreferrer"
                  className="w-10 h-10 bg-gray-900 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300"
                >
                  <SafeIcon icon={social.icon} className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white border-l-4 border-blue-600 pl-4">Navigation</h4>
            <ul className="space-y-4">
              {quickLinks.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.href} className="text-gray-400 hover:text-blue-400 transition-colors font-medium">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white border-l-4 border-blue-600 pl-4">Visit Us</h4>
            <div className="space-y-4 text-gray-400">
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="text-blue-500 mt-1 flex-shrink-0" />
                <span>14 Ada-George Road, Port-Harcourt City, Rivers State, Nigeria</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-blue-500 flex-shrink-0" />
                <span>+234 906 424 6172</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="text-blue-500 flex-shrink-0" />
                <span>info@southernsaviours.cc</span>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white border-l-4 border-blue-600 pl-4">Stay Informed</h4>
            <p className="text-gray-400 text-sm mb-4">Join our community updates and never miss a special service.</p>
            <form className="relative">
              <input 
                type="email" placeholder="Your email"
                className="w-full bg-gray-900 border-none rounded-xl py-3 px-4 text-sm focus:ring-2 focus:ring-blue-600 transition-all"
              />
              <button className="absolute right-2 top-1.5 bg-blue-600 hover:bg-blue-700 p-1.5 rounded-lg transition-colors">
                <SafeIcon icon={FiIcons.FiChevronRight} className="w-5 h-5" />
              </button>
            </form>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-900 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm">
          <p>© 2026 Southern Saviours Church. Built with faith.</p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;